import "./home.scss"
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import gaming from "./gaming.png"
import { useAuthState } from 'react-firebase-hooks/auth';
import { useState } from 'react';
import cls from "./close.png"
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { Link } from "react-router-dom"
import google from "./google.png"

firebase.initializeApp({
    apiKey: "AIzaSyAnzYwQZoS92SwESEjZyjMclAn8mq_mMZ4",
    authDomain: "tactime-5f55b.firebaseapp.com",
    projectId: "tactime-5f55b",
    storageBucket: "tactime-5f55b.appspot.com",
    messagingSenderId: "312243494453",
    appId: "1:312243494453:web:0be469bcd3bfdaa1479b7c",
    measurementId: "G-XGCTXHET5H"
})

const auth = firebase.auth();
const firestore = firebase.firestore();


function Home() {
    const [user] = useAuthState(auth)
    return (
        <div className="Home">
            {
                user ? <HomeContent /> : <AuthScreen />
            }
        </div>
    )
}

function HomeContent() {
    const [roomName, setRoomName] = useState("")
    const [user] = useAuthState(auth)
    const { displayName } = auth.currentUser
    const firstName = displayName.split(' ')[0];
    const [roomid, setRoomid] = useState("")


    const createRoom = async (e) => {
        e.preventDefault()

        const roomsRef = firestore.collection("rooms")
        const docId = roomsRef.doc().id
        firestore.collection("rooms").doc(docId).set({
            name: roomName,
            ouid: auth.currentUser.uid,
            members: 1,
            rid: docId,
            yp: "cross",
            mp: "zero",
            stateT: true
        },
            { merge: true })

        firestore.collection("rooms").doc(docId).collection("boxes").doc("values").set({
            box1: "null",
            box2: "null",
            box3: "null",
            box4: "null",
            box5: "null",
            box6: "null",
            box7: "null",
            box8: "null",
            box9: "null"
        })


        firestore.collection("rooms").doc(docId).collection("members").doc(auth.currentUser.uid).set({
            name: auth.currentUser.displayName,
            uid: auth.currentUser.uid,
            owner: "yes",
            member: "no"
        })

        setRoomName('')

        document.getElementById("createBox").style.display = "none"


    }

    const rooomRef = firestore.collection("rooms")
    const [roooms] = useCollectionData(rooomRef)

    const closeBox = () => {
        setRoomName('')
        setRoomid("")
        document.getElementById("createBox").style.display = "none"
        document.getElementById("joinRoom").style.display = "none"
    }
    const openBox = () => {
        document.getElementById("createBox").style.display = "flex"
    }


    const sendRqst = async (e) => {
        e.preventDefault()

        roooms && roooms.map(async (rd) => (
            rd.rid == roomid
                ? rd.ouid != auth.currentUser.uid
                    ? (
                        firestore.collection("rooms").doc(roomid).collection("requests").doc(auth.currentUser.uid).set({
                            name: auth.currentUser.displayName,
                            uid: auth.currentUser.uid,
                            rid: roomid
                        }, { merge: true }),
                        setRoomid(""),
                        alert("request sent"),
                        document.getElementById("joinRoom").style.display = "none"
                    )
                    : alert("You can't send request to yourself.")
                : null
        ))
    }



    const openJoinBox = () => {
        document.getElementById("joinRoom").style.display = "flex"
    }



    const signoo = async () => {
        auth.signOut();
    };

    var rcount = "present"
    roooms && roooms.map((r) => (
        r.ouid == auth.currentUser.uid || r.muid == auth.currentUser.uid
            ?
            rcount = "present"
            : null
    ))


    return (
        <>
            <div className='create-container' id='createBox'>
                <div className="create-box">
                    <div className="create-header">
                        <p className="sub-tagline">
                            Create room
                        </p>
                        <img className="close" onClick={closeBox} src={cls} />
                    </div>
                    <form className="create-form" onSubmit={createRoom} >
                        <input className="input-room-name" value={roomName} onChange={(e) => { setRoomName(e.target.value) }} required type="text" placeholder="Enter room name" />
                        <input className="create-button" type="submit" value="Submit" />
                    </form>
                </div>
            </div>

            <div className='create-container' id='joinRoom'>
                <div className="create-box">
                    <div className="create-header">
                        <p className="sub-tagline">
                            Join room
                        </p>
                        <img className="close" onClick={closeBox} src={cls} />
                    </div>
                    <form className="create-form" onSubmit={sendRqst} >
                        <input className="input-room-name" value={roomid} onChange={(e) => { setRoomid(e.target.value) }} required type="text" placeholder="Enter room name" />
                        <input className="create-button" type="submit" value="Submit" />
                    </form>
                </div>
            </div>

            <div className='HomeContent'>
                <br />
                <button className="join log-out" onClick={signoo} >Log out</button>
                <br /><br />
                <center>
                    <div className="welcome-boxx">
                        <center>
                            <p className='tagline tagHome'>
                                Welcome {firstName}
                            </p>
                            <p className='sub-tagline' >
                                Enjoy!!
                            </p>
                        </center>
                        <div className='home-buttons'>
                            <button onClick={openBox} className='create create-room '>
                                Create Room
                            </button>
                            <button onClick={openJoinBox} className='join join-room'>
                                Join Room
                            </button>
                        </div>
                    </div>
                </center>
                <br />
                <div className="rooms-container">
                    <p className="sub-tagline" >Rooms</p>
                    <br />
                    <div className="rooms-box">
                        {
                            rcount == "none"
                                ? <p>No room to show</p>
                                : (
                                    roooms && roooms.map((rd) => (

                                        rd.ouid == auth.currentUser.uid || rd.muid == auth.currentUser.uid
                                            ? (
                                                <div className="room" >
                                                    <Link to={`/rooms/${rd.rid}`}>
                                                        <p className="room-name" >{rd.name}</p>
                                                        {
                                                            rd.muid == auth.currentUser.uid
                                                                ? <p className="joined" >Joined</p>
                                                                : <p className="joined">Owned</p>
                                                        }
                                                    </Link>
                                                </div>
                                            )
                                            : null

                                    ))
                                )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

function AuthScreen() {



    const signInWithGoogle = async (e) => {


        e.preventDefault(e)
        const provider = await new firebase.auth.GoogleAuthProvider();
        await auth.signInWithPopup(provider);

        await firestore.collection("users").doc(auth.currentUser.uid).set({
            name: auth.currentUser.displayName,
            uid: auth.currentUser.uid,
            pic: auth.currentUser.photoURL,
        }, { merge: true })


    }


    return (
        <div className='AuthScreen'>

            <div className="home-box">
                <div className="home-img-box">
                    <img className="home-img" src={gaming} />
                </div>
                <div className="right-home">
                    <center>
                        <p className='tagline tagHome'>
                            Welcome to TacTime
                        </p>
                        <p className='sub-tagline' >
                            A multiplayer Tic Tac Toe game
                        </p>
                    </center>
                    <div className='home-buttons'>
                        <div onClick={signInWithGoogle} className='google-button'>
                            <div className="google-box"  >
                                <img className="google" src={google} />
                            </div>
                            <p className="google-text">Sign In with Google</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;